/* Smoke + Forge — Kill Instagram Feed v5

 * Targets the ENTIRE shopify-block container, not just inner elements.

 * Runs immediately and aggressively.

 */

(function() {

  if (window.innerWidth > 749) return;

  var n = 0;

  function k() {

    // Target the entire shopify-block wrapper for the Instagram app

    var blocks = document.querySelectorAll(

      '.shopify-app-block, [class*="shopify-block-"][class*="gsc"]'

    );

    for (var i = 0; i < blocks.length; i++) {

      var sec = blocks[i].closest('.shopify-section');

      if (sec) sec.remove();

      else blocks[i].remove();

    }


    // Also target by section id pattern

    var sections = document.querySelectorAll(

      '[id*="gsc_instagram"], [id*="17698049446f463d64"]'

    );

    for (var j = 0; j < sections.length; j++) {

      sections[j].remove();

    }


    // And the gsc class elements + scripts (belt and suspenders)

    var sels = '.gsc-instafeed,[class*="gsc-instafeed"],[class*="gsc_instafeed"],[id*="gsc-instafeed"],[id*="GSC-"],.gfa-carousel,[class*="gfa-carousel"],[class*="gfa-media"]';

    var els = document.querySelectorAll(sels);

    for (var l = 0; l < els.length; l++) {

      els[l].remove();

    }

    var scripts = document.querySelectorAll('script[src*="gsc-instafeed"]');

    for (var m = 0; m < scripts.length; m++) {

      scripts[m].remove();

    }

  }

  k();

  var iv = setInterval(function() { k(); if (++n > 60) clearInterval(iv); }, 50);

})();